import { LogoHeader } from "../Components/Inicio/LogoHeaderComponent";
import { NavDesktop } from "../Components/Inicio/NavDesktop";
import { NavMobile } from "../Components/Inicio/NavMobile";
import { TerminosComponent } from "../Components/Footer/TerminosComponent";
import { Footer } from "../Components/Footer/FooterComponent";

export const Terminos = (props) => {
    return (
        <>
            <LogoHeader I18n={props.I18n} />
            <NavDesktop I18n={props.I18n} />
            <NavMobile I18n={props.I18n} />
            <TerminosComponent I18n={props.I18n} />
            <Footer I18n={props.I18n} />
        </>

    )
}